const configuredBaseUrl = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api"
).replace(/\/+$/, "");

function resolveApiBaseUrl() {
  if (process.env.NODE_ENV !== "development" || typeof window === "undefined") {
    return configuredBaseUrl;
  }

  try {
    const backend = new URL(configuredBaseUrl);
    const frontend = new URL(window.location.href);
    const isLocalHost = (host) => ["localhost", "127.0.0.1"].includes(host);
    if (
      isLocalHost(frontend.hostname) &&
      isLocalHost(backend.hostname) &&
      backend.port === "5000"
    ) {
      return backend.pathname.replace(/\/+$/, "") || "/api";
    }
  } catch {}
  return configuredBaseUrl;
}

export const API_BASE_URL = resolveApiBaseUrl();
export const TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const USER_ID_KEY = "userId";
export const DEVICE_ID_KEY = "deviceId";
export const WALLET_KEY = "wallet";
